/**
 * screens/Overview/emptyState.ts
 * Copy for the educational panel this screen shows when the org holds no cash
 * yet. Kept beside the screen rather than in a shared copy file: each screen's
 * flow strip highlights ITS position in the chain, so the content is
 * screen-specific even though the component is not.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const OVERVIEW_FLOW: readonly FlowNode[] = [
  { key: 'assign', label: 'Assign', sub: 'cash into custody', here: true },
  { key: 'record', label: 'Record', sub: 'spends and collections' },
  { key: 'count', label: 'Count', sub: 'prove the balance' },
  { key: 'route', label: 'Route', sub: 'to Payroll or Billing' },
];

export const OVERVIEW_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'Assign cash to a holder',
    hint: 'A person, a vehicle, a shift, a store — anyone who can hold money.',
  },
  {
    n: '2',
    label: 'They record what they spend',
    hint: 'Every movement is a ledger row. Nothing is ever edited or deleted.',
  },
  {
    n: '3',
    label: 'A count proves the balance',
    hint: 'Any difference is routed to Payroll or Billing, or waived with a reason.',
  },
];

export const OVERVIEW_COPY = {
  eyebrow: 'Cash position',
  title: 'Nobody holds company cash yet',
  blurb:
    'This console records who holds money outside the bank, every movement of it, and the count that proves the balance. It never moves money itself.',
  flowNote:
    'Company Cash is a subledger. The bank and the general ledger remain the money of record — this is the record of custody.',
  footNote: 'Assign cash to your first holder to begin.',
} as const;
